import { CopyButton } from '@/components/copy-button';

type DocumentMetadataFooterProps = {
  filePath: string;
  fileType: string;
};

export function DocumentMetadataFooter({ filePath, fileType }: DocumentMetadataFooterProps) {
  return (
    <div className="border-t pt-4 px-4 space-y-4">
      {/* Document Path */}
      <div className="flex items-center justify-between gap-4">
        <div className="space-y-1 flex-1 min-w-0">
          <label className="text-xs text-muted-foreground font-medium">Document Path</label>
          <p className="text-xs text-foreground font-mono truncate">{filePath}</p>
        </div>
        <CopyButton value={filePath} tooltip="Copy path" className="size-6" tabIndex={-1} />
      </div>

      {/* Compact metadata grid */}
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-1">
          <label className="text-xs text-muted-foreground font-medium">Type</label>
          <p className="text-xs text-foreground">{fileType}</p>
        </div>
      </div>
    </div>
  );
}
